import { IExerciseSelectionFilter } from '../../logic/workoutselection/workoutselectionmanager';
import { Exercise, ExerciseFormat } from '../exercise';
import { WorkoutSettings } from '../user';
import { ExerciseSelection } from '../workout/exerciseselection';
import { ExerciseAnalysisForZoneAndStage, IFilterNameAndCount } from './exerciseanalysisforzoneandstage';

export default class WorkoutSelectionAnalysis {
    public stages: ExerciseAnalysisForZoneAndStage[] = [];
    public finalExercisesInDisplayableFormat: string[] = [];
    constructor(
        public settings: WorkoutSettings,
        public dateOfWorkout: Date,
    ) {

    }

    public addStageAnalysis(stage: number, zone: number) {
        if (this.getStageAnalysis(stage)) {
            throw new Error('Stage already added');
        }
        this.stages.push(new ExerciseAnalysisForZoneAndStage(stage, zone));
    }

    public addFilterNameCountToStageAnalysis(
        stage: number,
        exercises: Exercise[],
        filterNameCount: IFilterNameAndCount) {
        const stageAnalysis = this.getStageAnalysis(stage);

        if (!stageAnalysis) {
            throw new Error(`Stage ${stage} not in list of stages`);
        }
        stageAnalysis.addToFilterProgression(filterNameCount, exercises);
    }

    public setErrorForFilter(stage: number, filter: IExerciseSelectionFilter) {
        const stageAnalysis = this.getStageAnalysis(stage);
        if (!stageAnalysis) {
            throw new Error(`Stage ${stage} not in list of stages`);
        }

        stageAnalysis.addFilterError(filter);
    }

    public setFinaleExercisesForStage(exercises: Exercise[], stage: number) {
        const stageAnalysis = this.getStageAnalysis(stage);
        if (!stageAnalysis) {
            throw new Error(`Stage ${stage} not in list of stages`);
        }
        stageAnalysis.setFinaleExercises(exercises);
    }

    public setGeneratedExerciseSessionForStage(exerciseSelection: ExerciseSelection, stage: number) {
        const stageAnalysis = this.getStageAnalysis(stage);
        if (!stageAnalysis) {
            throw new Error(`Stage ${stage} not in list of stages`);
        }
        // TODO
        // stageAnalysis.selectedExerciseSession = null;
    }

    public csvHeader(): string {
        if (this.stages.length < 1) {
            throw new Error('No stages to build header from');
        }
        return `Ref,Date,LevelSetting,BagContactSetting,BurnOrBuildSetting,BodyGroupsSetting` +
            `,${this.stages[0].csvHeader()}`;
    }

    public csvBody(exerciseFormatsToIgnore: ExerciseFormat[]): string {
        if (this.stages.length < 1) {
            throw new Error('No stages to build body from');
        }
        let csvString = '';
        this.stages.forEach((stage: ExerciseAnalysisForZoneAndStage) => {
            const ex = stage.selectedExerciseSession;
            if (!this.isFormatInIgnoredFormats(ex.format, exerciseFormatsToIgnore)) {
                csvString += `${this.stageCsvLine(stage.stage)}\n`;
            }
        });
        return csvString;
    }

    public stageCsvLine(stage: number): string {
        const stageAnalysis = this.getStageAnalysis(stage);
        if (!stageAnalysis) {
            throw new Error(`Stage ${stage} not in list`);
        }
        return `${this.getDateAndSettingsCsv()},${stageAnalysis.stageZoneCountToCsv()}`;
    }

    public orderByZone() {
        this.stages = this.stages.sort((a: ExerciseAnalysisForZoneAndStage, b: ExerciseAnalysisForZoneAndStage) =>
            a.zone > b.zone ? 1 : -1);
    }

    public orderByStage() {
        this.stages = this.stages.sort((a: ExerciseAnalysisForZoneAndStage, b: ExerciseAnalysisForZoneAndStage) =>
            a.stage > b.stage ? 1 : -1);
    }

    private getDateAndSettingsCsv(): string {
        const dateOfWorkout = this.dateOfWorkout;
        const level = this.settings.level;
        const allowBagContact = this.settings.allowBagContact;
        const cardioOrResistance = this.settings.cardioOrResistance;
        const threeBodyGroups = this.settings.threeBodyGroups.join('; ');
        const conbinationString = (`${dateOfWorkout}${level}${allowBagContact}${cardioOrResistance}${threeBodyGroups}`);

        return `${conbinationString.toUpperCase()},${dateOfWorkout},${level},${allowBagContact},` +
            `${cardioOrResistance},${threeBodyGroups}`;
    }

    private getStageAnalysis(stage: number): ExerciseAnalysisForZoneAndStage | undefined {
        return this.stages.find((zs: ExerciseAnalysisForZoneAndStage) => zs.stage === stage);
    }

    private isFormatInIgnoredFormats(format: ExerciseFormat, ignoredFormats: ExerciseFormat[]): boolean {
        return ignoredFormats.indexOf(format) > -1;
    }
}
